import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import YouTube from 'react-youtube'
import theme from 'ui/styles/theme'

export default class Focus extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      visible: false,
      youtubeVisible: false,
      isMobile: false
    }

    this.wrapper = React.createRef()
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.detectMobile)
    
    this.handleScroll()
    this.detectMobile()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.detectMobile)
  }

  handleScroll = () => {
    const rect = this.wrapper.current.getBoundingClientRect()

    if(rect.top * 1.5 < window.innerHeight) {
      window.removeEventListener('scroll', this.handleScroll)

      this.setState({ visible: true })
    }
  }

  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.md
    
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }

  toggleYoutube = () => {
    const { youtubeVisible } = this.state

    console.log('clicked')
    
    this.setState({ youtubeVisible: !youtubeVisible })
  }

  render() {
    const {
      title,
      text,
      buttonText,
      buttonLink,
      video,
      videoMobile,
      image,
      youtube
    } = this.props

    const {
      visible,
      youtubeVisible,
      isMobile
    } = this.state

    return (
      <Wrapper innerRef={this.wrapper}>
        {youtube && (
          <PlayButton onClick={this.toggleYoutube}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="15"
              viewBox="0 0 12 15"
            >
              <path fill="#FFF" fillRule="evenodd" d="M12.025 7.4L0 14.8V0z"></path>
            </svg>
          </PlayButton>
        )}

        <FloatingContainer layer={2}>
          <Container fluid style={{ height: '100%' }}>
            <Row alignItems="stretch" style={{ height: '100%' }}>
              <Col sm={4}>
                <TextContainer visible={visible}>
                  <Title>{title}</Title>
                  <div>
                    <Text>{text}</Text>
                    {buttonText && buttonLink && (
                      <Button to={getRelativeUrl(buttonLink)}>{buttonText}</Button>
                    )}
                  </div>
                </TextContainer>
              </Col>
            </Row>
          </Container>
        </FloatingContainer>


        <FloatingContainer layer={1}>
          <Container fluid style={{ height: '100%' }}>
            <Row alignItems="stretch" style={{ height: '100%' }}>
              <Col sm={1}>
                <CoverLeft visible={visible} />
              </Col>

              <Col sm={1} smOffset={10}>
                <CoverRight visible={visible} />
              </Col>
            </Row>
          </Container>
        </FloatingContainer>

        {youtubeVisible && (
          <YouTubeOverlay onClick={this.toggleYoutube}>
            <YouTube
              videoId={youtube}
              opts={{
                playerVars: {
                  autoplay: 1,
                }
              }}
            />
          </YouTubeOverlay>
        )}
        
        {video ? (
          <Video src={isMobile ? videoMobile.sourceUrl : video.sourceUrl} autoPlay muted loop playsInline />
        ) : (
          <Image src={image.sourceUrl} />
        )}
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 65px;
  position: relative;
  overflow: hidden;
`

const FloatingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${props => props.layer ? props.layer : 0};
`

const Cover = styled.div`
  width: 200%;
  height: 100%;
  background: white;
  position: absolute;
  top: 0;
  transition: transform 1.5s ${easing.easeOutCubic};
`

const CoverLeft = styled(Cover)`
  right: -20px;
  transform: translateX(${props => props.visible ? '-100%' : 0});
`

const CoverRight = styled(Cover)`
  left: -20px;
  transform: translateX(${props => props.visible ? '100%' : 0});
`

const Video = styled.video`
  width: 100%;

  ${media.xs`
    height: 75vh;
    object-fit: cover;
    display: block;
  `}
`

const Image = styled.img`
  width: 100%;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  color: white;
  transition: opacity 0.5s ${easing.easeOutCubic};
  transition-delay: 0.75s;
  opacity: ${props => props.visible ? 1 : 0};
  padding: 45px;

  ${media.xs`
    padding: 20px 0;
  `}
`

const Title = styled.h2`
  font-size: 40px;
  line-height: 42px;
  font-weight: 300;
  margin-top: 1em;

  ${media.xs`
    margin-top: 0;
    font-size: 30px;
    line-height: normal;
  `}
`

const Text = styled.p`
  font-size: 18px;
  font-weight: 300;
  line-height: 22px;
`

const Button = styled(Link)`
  font-size: 11px;
  font-weight: 500;
  color: white;
  text-decoration: none;
  padding: 0.5em 1.5em;
  border: 1px solid white;
  border-radius: 2em;
  text-transform: uppercase;
`

const PlayButton = styled.button`
  width: 74px;
  height: 74px;
  border-radius: 100%;
  background: ${props => props.theme.colors.primary};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  &:hover {
    cursor: pointer;
  }
`

const YouTubeOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 80%;
    height: 0;
    padding-bottom: 45%;
    position: relative;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/Focus/index.js